var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6508_258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3229 16.1562C45.7923 16.1562 44.5478 14.9262 44.5478 13.4133L44.5478 9.4588L34.7791 19.5142C33.7151 20.6089 31.9605 20.6396 30.853 19.5941C29.7454 18.5424 29.7143 16.8081 30.7721 15.7134L40.7088 5.48586L36.7764 5.48586C35.2458 5.48586 34.0014 4.25584 34.0014 2.74293C34.0014 1.23001 35.2458 1.76958e-09 36.7764 2.28591e-09L47.3167 5.84149e-09C48.8473 6.35783e-09 50.0917 1.23001 50.0917 2.74293L50.0917 13.4133C50.0917 14.9262 48.8473 16.1562 47.3167 16.1562L47.3229 16.1562Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76884 32.8456C5.29948 32.8456 6.5439 34.0756 6.5439 35.5885L6.5439 39.543L16.3126 29.4876C17.3766 28.3929 19.1312 28.3622 20.2388 29.4077C21.3463 30.4593 21.3774 32.1937 20.3197 33.2884L10.3829 43.5159L14.3153 43.5159C15.846 43.5159 17.0904 44.7459 17.0904 46.2588C17.0904 47.7718 15.846 49.0018 14.3153 49.0018L3.77506 49.0018C2.24442 49.0018 1 47.7718 1 46.2588L1 35.5885C1 34.0756 2.24442 32.8456 3.77506 32.8456L3.76884 32.8456Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6508_258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.28125) rotate(0.324268)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.5384fe67de1f153b829c6834af4c1c71.svg";
export { ForwardRef as ReactComponent };